import type { Resource } from '../../';
export const cart_couponCodes_rejection_limitReached: Resource = {"default":"The requested coupon has reached its redemption limit."};
